import * as React from 'react';
import renderHTML from 'react-render-html';
import { percentageFormat, numberWithCommas } from '../../Common/Helpers';

interface Props {
    total_employees?: any;
    total_students?: any;
    top_heading?: any;
    list_agencies?: any;
    report_display_id?: any;
}

class AgencyChart extends React.Component<Props, {}> {
    render() {
        const { top_heading, list_agencies, report_display_id } = this.props;

        if (list_agencies && list_agencies.length > 0) {
            const result = list_agencies[0].hasOwnProperty("agy");

            return (
                <div className="row">
                    <div className="col-md-12">
                        <div>
                            <h3 style={{ paddingTop: "20px" }}>{top_heading !== undefined && renderHTML(top_heading)}</h3>
                            <table className="table">
                                {(result && report_display_id != "999040") &&
                                    <thead><tr><th style={{ width: "50%" }}>Agency</th>
                                        <th style={{ width: "15%", textAlign: "center" }}>Employees</th>
                                        <th style={{ width: "35%", textAlign: "right" }}>% students</th>
                                    </tr></thead>
                                }
                                {(!result || report_display_id == "999040") &&
                                    <thead><tr><th style={{ width: "50%" }}>Agency</th>
                                        <th style={{ width: "15%", textAlign: "right" }}>Amount</th>
                                        <th style={{ width: "35%", textAlign: "right" }}># of Grants</th>
                                    </tr></thead>
                                }
                                {(result && report_display_id != "999040") &&
                                    <tbody>
                                        {list_agencies.map(function (table, index) {
                                            return (<tr key={index}><td>{table.agy?.replace("NoN","Non")}</td>
                                                <td style={{ textAlign: "right" }}>{numberWithCommas(table.total)}</td>
                                                <td style={{ textAlign: "right" }}>{percentageFormat(table.percent_students, 0)}</td>
                                            </tr>);
                                        })}
                                    </tbody>
                                }
                                {(!result || report_display_id == "999040") &&
                                    <tbody>
                                        {list_agencies.map(function (table, index) {
                                            return (<tr key={index}><td>{table.agency.replace("NoN", "Non")}</td>
                                                <td style={{ textAlign: "right" }}>{table.amount}</td>
                                                <td style={{ textAlign: "right" }}>{table.numberOfGrants}</td>
                                            </tr>);
                                        })}
                                    </tbody>
                                }
                            </table>
                        </div>
                    </div>
                </div>
            );
        }
        else return (<div></div>)
    }
}

export default AgencyChart;